import { FC } from 'react';

import { RequiredRule } from 'devextreme-react/cjs/form';
import { DropDownOptions } from 'devextreme-react/cjs/select-box';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox, TextBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { AccountEdit } from 'pages/Accounts/Accounts.entity';

type Props = {
  employeeDateSource: DataSource;
  roleSource: DataSource;
  form: AccountEdit;
  onChange: (name: keyof AccountEdit, value: AccountEdit[keyof AccountEdit]) => void;
};

export const AccountEditForm: FC<Props> = ({ employeeDateSource, roleSource, form, onChange }) => {
  return (
    <div>
      <AppFieldBox label="ФИО" labelTop>
        <SelectBox
          stylingMode="underlined"
          dataSource={employeeDateSource}
          displayExpr="fullName"
          valueExpr="id"
          value={form.employeeId}
          searchEnabled
          onItemClick={(e) => {
            onChange('employeeId', e.itemData.id);
          }}
        >
          <DropDownOptions title="Выберите контрагента" closeOnOutsideClick={true} showTitle={false} />
          <Validator>
            <RequiredRule message="Выберите контрагента" />
          </Validator>
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Роль" labelTop>
        <SelectBox
          stylingMode="underlined"
          style={{ width: '100%' }}
          placeholder="Выберите роль"
          mode="text"
          value={form.roleId}
          onItemClick={(e) => {
            onChange('roleId', e.itemData.id);
          }}
          displayExpr="name"
          searchEnabled={true}
          searchExpr={['name']}
          dataSource={roleSource}
        >
          <Validator>
            <RequiredRule message="Выберите роль" />
          </Validator>
        </SelectBox>
      </AppFieldBox>

      <AppFieldBox label="Логин" labelTop>
        <TextBox
          stylingMode="underlined"
          placeholder="Введите логин"
          mode="text"
          value={form.userName}
          onValueChange={(e) => onChange('userName', e)}
        >
          <Validator>
            <RequiredRule message="Заполните поле логин" />
          </Validator>
        </TextBox>
      </AppFieldBox>
    </div>
  );
};
